import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
// import { Pagination } from "react-bootstrap";
import { getRequest } from "services/api";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const TierContext = createContext();

export const TierProvider = ({ children }) => {
  const [tiers, setTiers] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    // limit: 500,
    // limit: LIMIT_DATA_PER_PAGE,
    // tambahkan "include":"products"
    // include: "products",
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchTiers = useCallback(async () => {
    setTiers((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/tier${queryString}`);
      if (response.success) {
        setTiers({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        setFilterOptions((prev) => ({
          ...prev,
          totalPages: response.pagination.last_page,
        }));
      }
    } catch (error) {
      setTiers({
        data: [],
        pagination: null,
        error: error.message,
        loading: false,
      });
    }
  }, [queryString]);

  useEffect(() => {
    fetchTiers();
  }, [fetchTiers]);

  const handlePageChange = (page) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  const totalPages = tiers.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages: totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  return (
    <TierContext.Provider
      value={{
        tiers,
        filterOptions,
        handleSearch,
        // fetchTiers,
        refetch: fetchTiers,
        Pagination,
      }}
    >
      {children}
    </TierContext.Provider>
  );
};
export const useTier = () => {
  const context = useContext(TierContext);
  if (!context) {
    throw new Error("useTier must be used within TierProvider");
  }

  const fetchOptions = async (inputValue) => {
    const response = await getRequest(`/tier?search=${inputValue}`);
    if (response.success) {
      return response.data.map((tier) => ({
        value: tier.id,
        label: tier.name,
      }));
    }
    return [];
  };
  // return context;
  return { ...context, fetchOptions };
};
